<template>
  <el-dialog :visible.sync="dialogVisible" z-index="1000">
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
</template>

<script>
    export default {
        name: 'ImagePreview',
        data () {
            return {
                dialogImageUrl: '',
                dialogVisible: false
            }
        },
        methods: {
            handlePictureCardPreview(url) {
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ImagePreview.vue